module.exports = __webpack_public_path__ + "gm.6d599b7f3aceda27611d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gm.svg
// module chunks = styles